import React from 'react';

import { Table } from 'react-bootstrap';

import StripeChargesRow, { StripeChargeRowProps } from './StripeChargesRow';

type Props = {
  charges: StripeChargeRowProps[];
};

const StripeChargesTable = (props: Props) => (
  <Table responsive>
    <thead>
      <tr>
        <th />
        <th>Charge ID</th>
        <th>Amount</th>
        <th>Status</th>
        <th>Date</th>
        <th />
        <th />
      </tr>
    </thead>
    <tbody>
      {props.charges.map(charge => (
        <StripeChargesRow key={charge.id} {...charge} />
      ))}
    </tbody>
  </Table>
);

export default StripeChargesTable;
